import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import IdoStepsImage from "../../assets/images/ido-steps/ido-steps.png";
import ApplyToWhitelistImage from "../../assets/images/ido-steps/apply-to-whitelist.png";
import DealDetailsImage from "../../assets/images/ido-steps/deal-details.png";
import DealsStepsImage from "../../assets/images/ido-steps/deals-step.png";
import LastStepImage from "../../assets/images/ido-steps/last-step.png";
import MyGainsImage from "../../assets/images/ido-steps/my-gains.png";
import QuizStepImage from "../../assets/images/ido-steps/quiz-step.png";
import StakingStepImage from "../../assets/images/ido-steps/staking-step.png";
import DurationBonus from "../../assets/images/ido-steps/duration-bonus.png";
import TierSystemImage from "../../assets/images/ido-steps/5-tier-system.png";
import WalletConnectStep from "../../assets/images/ido-steps/wallet-connect-step.png";
import { Link, useLocation } from "react-router-dom";
import { useContext, useEffect } from "react";
import AuthContext from "../../store/Auth/AuthContext";
import AdminHeader from "../SubComponents/AdminHeader";
import Header from "../SubComponents/Header";
import Footer from "../SubComponents/Footer";

const useStyles = makeStyles(() => ({
  image: {
    width: "100%",
    height: "auto",
    display: "block",
    borderRadius: ".5rem",
    margin: "2rem 0",
    border: "1px solid rgba(0, 0, 0, 0.25)",
  },
  text: {
    fontSize: "1.2rem",
    lineHeight: 1.5,
    "& span": {
      fontWeight: 700,
    },
    "@media (max-width: 768px)": {
      fontSize: "1rem",
    },
  },
  grid: {
    gap: "3rem",
    "@media (max-width: 768px)": {
      gap: "1.5rem",
    },
  },
  link: {
    color: "#3eb8aa",
    fontWeight: 700,
  },
}));

export default function IdoStepByStep() {
  const classes = useStyles();
  const location = useLocation();

  const { isAuth } = useContext<any>(AuthContext);

  const Image = ({ src, alt }: { src: string; alt: string }) => {
    return <img src={src} alt={alt} className={classes.image} />;
  };

  useEffect(() => {
    if (location.hash) {
      const section = document.getElementById(location.hash.replace("#", ""));
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location.hash]);

  return (
    <>
      {isAuth ? <AdminHeader /> : <Header timer={false} authPage />}
      <Container
        maxWidth="lg"
        style={{
          marginTop: "2rem",
          marginBottom: "2rem",
        }}
        className="ido-steps"
      >
        <Grid container direction="column" className={classes.grid}>
          <Grid item>
            <ProjectPoolHeading title1="GainsPad IDO Step-by-Step" />
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              Join GainsPad’s IDOs. Deals are fully refundable, with listings a
              few days after investment.
            </Typography>

            <Image src={IdoStepsImage} alt="ido steps" />

            <Typography variant="h3" className="mb-16">
              Step 1: Ensure you hold the required amount of $GAINS for IDO
              participation
            </Typography>
            <Typography
              variant="body1"
              className={classes.text + " mb-16"}
              color="secondary"
            >
              Watch a short tutorial on how to buy $GAINS tokens:{" "}
              <a
                href="https://youtu.be/n4hSKZqwsD0"
                target="_blank"
                rel="noopener"
                className={classes.link}
              >
                Click here to watch
              </a>
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              <span>Lottery system:</span> Staking a minimum of 1,000 $GAINS
              enters you into a lottery for GainsPad IDO eligibility. With
              higher stakes increasing your potential allocation.
              <br />
              <span>Guaranteed allocation:</span> If you lock at least 100,000
              $GAINS on the platform, you will be eligible for guaranteed
              allocation. And as you may guess, the more $GAINS you lock, the
              more allocation you may win.
              <br />
              <span>Fairness:</span> If missed previous IDOs, bonus of 15, 30
              and 50% if 1, 2 or 3+ missed in a row.
            </Typography>
          </Grid>
          <Grid item>
            <Box padding="2rem 0">
              <Image src={TierSystemImage} alt="ido steps image" />
            </Box>
            <Typography variant="h3" className="mb-16">
              Step 2: Connect Your Wallet to GainsPad Web Page
            </Typography>
            <Typography
              variant="body1"
              className={classes.text + " mb-16"}
              color="secondary"
            >
              Watch a short tutorial on how to onboard and invest:{" "}
              <a
                href="https://www.youtube.com/watch?v=UF42JHS-eFA"
                target="_blank"
                rel="noreferrer"
                className={classes.link}
              >
                Click here to watch
              </a>
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              Login on{" "}
              <Link
                target="_blank"
                rel="noopener"
                to={"/deals"}
                className={classes.link}
              >
                {" "}
                GainsPad
              </Link>
              , click "Connect Wallet" in the top right and select your wallet.
              We recommend Metamask for the ease of use.
            </Typography>
            <Image src={WalletConnectStep} alt="staking step" />
          </Grid>
          <Grid item>
            <Typography variant="h3" className="mb-16">
              Step 3: Stake your $GAINS
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              To join IDOs on GainsPad, connect your wallet and stake your
              $GAINS tokens on{" "}
              <Link
                to={"/gains"}
                target="_blank"
                rel="noopener"
                className={classes.link}
              >
                the official staking page
              </Link>
              , then click "Stake GAINS" to proceed. The longer you stake your
              $GAINS, the more allocation you may win.
              <br />
            </Typography>
            <Image src={DurationBonus} alt="staking step" />
            <Typography variant="h4" className="mb-16">
              Here is the process:
            </Typography>
            <Image src={StakingStepImage} alt="staking step" />
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              <span className="fw-bold">A.</span> After staking your $GAINS,
              you're set to join any IDO on GainsPad. You can add more $GAINS to
              your stake at any time, each with its own staking period,
              independent of earlier stakes.
            </Typography>
            <Image src={MyGainsImage} alt="my-gains" />
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              <span className="fw-bold">B.</span> Post-stake, you'll see your
              $GAINS in a table. To unstake, click 'Withdraw' and confirm in
              your wallet to return the tokens to it.
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h3" className="mb-16">
              Step 4: Complete Whitelist Requirement
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              $GAINS holders must register for a whitelist to participate in
              IDOs.
              <Image src={DealsStepsImage} alt="deals-step" />
              <span className="fw-bold">A.</span> Go to{" "}
              <Link
                to={"/deals"}
                target="_blank"
                rel="noopener"
                className={classes.link}
              >
                Deals page
              </Link>
              , apply for an open whitelist like DexCheck. Your allocation
              depends on your tickets—1 ticket per 1,000 staked GAINS. More
              tickets mean a bigger allocation.
              <Image src={DealDetailsImage} alt="deal-details" />
              <span className="fw-bold">B.</span> Click “Get Whitelisted”
              <Image src={ApplyToWhitelistImage} alt="apply-to-whitelist" />
              <span className="fw-bold">C.</span> Click "Apply For Whitelist" or
              increase your stake for extra lottery tickets.
              <Image src={QuizStepImage} alt="quiz-step" />
              <span className="fw-bold">D.</span> Learn about the project by
              completing a quiz.
              <Image src={LastStepImage} alt="last-step" />
              <span className="fw-bold">E.</span> Soon, you'll receive an email
              about potentially participating in an IDO.
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h3" className="mb-16">
              Step 5: Win Allocation
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              IDO Whitelist Winners will be announced on GainsPad's main TG and
              Twitter, and by email, about 24 hours before the IDO, with details
              on purchase time, claiming, and listing. You can buy your
              allocation as the sale starts at{" "}
              <Link
                className={classes.link}
                target="_blank"
                rel="noopener"
                to="/deals"
              >
                Deals page
              </Link>{" "}
              by connecting to the IDO pool.
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="h3" className="mb-16">
              Step 6: Claiming
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              If you win an allocation and join the IDO, you can either:
              <br />
              <br />
              <span className="fw-bold">A.</span> Receive the IDO tokens
              automatically in your wallet, simplifying the process on the
              GainsPad. <br />
              <br /> <span className="fw-bold">B.</span> Manually claim them
              from each project's page.
            </Typography>
          </Grid>

          <Grid item component="section" id="refund-info">
            <Typography variant="h3" className="mb-16">
              How to get a refund ?
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              With us, satisfaction is guaranteed or your money back. You won't
              have to deal with the uncertainties of the crypto market.
              <br />
              <span className="fw-bold">
                For each project, there's a 12 to 48-hour window to request a
                refund if the ROI doesn't meet your expectations.
              </span>
              <br />
              <span className="fw-bold">
                Note: The refund window opens after TGE ( Token Generation Event
                ).
              </span>
            </Typography>
          </Grid>
          <Grid item component="section" id="more-info">
            <Typography variant="h2" className="mb-16">
              Want to do more?
            </Typography>
            <Typography
              variant="body1"
              color="secondary"
              className={classes.text}
            >
              The staking modules of{" "}
              <a
                href="https://app.gains-associates.com"
                target="_blank"
                rel="noreferrer"
              >
                GainsPrivate
              </a>{" "}
              and GainsPad are merged. This means stakers on either side now get
              access to both platforms, offering more flexibility for everyone.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}
